export default (axios, path = '/product') => ({
  save: async (product) => {
    return await axios.post(`${path}`, product)
  },
  findAllByGameId: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}`,)
  },
  findSoldProductsForTeam: async (teamId) => {
    return await axios.get(`${path}/team/${teamId}/purchases`)
  },
  findAllSoldProducts: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}/purchases`)
  },
  findAllByTeamId: async (teamId) => {
    return await axios.get(`${path}/team`, {teamId})
  },
  findAllArchivedByTeamId: async (teamId) => {
    return await axios.get(`${path}/team/${teamId}/history`)
  },
  delete: async (id) => {
    return await axios.delete(`${path}/${id}`)
  },
})
